var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useRef } from "react";
import { StyledToggleSwitchContainer, StyledSlider, StyledLabel, StyledToggleContainer } from "./Toggle.style";
import Box from "../box/Box";
import { trapEvent } from "../../utils/EventHelpers";
import useAutoFocus from "../../hooks/useAutoFocus";
import useUniqueId from "../../hooks/useUniqueId";
import useIdAttrs from "../../hooks/useIdAttrs";
import InfoIconTooltip from "../with-tooltip/InfoIconTooltip";
import Flex from "../box/Flex";
import { apolloSpaceInsetHalfX } from "@nexthink/apollo-tokens";
const prefixId = "nx-toggle-";
const Toggle = (_a) => {
    var { id: defaultId, "data-insights": insightsAttr, checked, onChange, size = "large", disabled = false, label, autoFocus: initialAutoFocus = false, onFocus, onBlur, name, infoTooltip } = _a, rest = __rest(_a, ["id", "data-insights", "checked", "onChange", "size", "disabled", "label", "autoFocus", "onFocus", "onBlur", "name", "infoTooltip"]);
    const id = useUniqueId(prefixId, defaultId);
    const idAttrs = useIdAttrs({ id, insightsAttr });
    const autoFocus = initialAutoFocus && !disabled;
    const [focused, setFocused] = useState(autoFocus);
    const ref = useRef(null);
    useAutoFocus(ref, autoFocus);
    const handleOnFocus = (e) => {
        setFocused(true);
        if (onFocus) {
            onFocus(e);
        }
    };
    const handleOnBlur = (e) => {
        setFocused(false);
        if (onBlur) {
            onBlur(e);
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            onChange(!checked);
            trapEvent(e);
        }
    };
    return (React.createElement(Box, { display: "inline-flex" },
        React.createElement(StyledToggleContainer, { alignItems: "center", focused: focused, onClick: (e) => {
                e.stopPropagation();
            } },
            label && (React.createElement(StyledLabel, Object.assign({}, idAttrs("-label"), { variant: "bodySmall", toggleSize: size, disabled: disabled }), label)),
            React.createElement("input", Object.assign({}, idAttrs(), { ref: ref, type: "checkbox", name: name, disabled: disabled, onFocus: handleOnFocus, onBlur: handleOnBlur, onKeyDown: handleKeyDown, checked: checked, readOnly: true }, (!disabled && {
                onChange: () => {
                    onChange(!checked);
                },
            }), (label && { "aria-labelledby": `${id}-label` }), rest)),
            React.createElement(StyledToggleSwitchContainer, { size: size, disabled: disabled, onClick: (e) => {
                    trapEvent(e);
                    !disabled && onChange(!checked);
                }, "data-checked": checked },
                React.createElement(StyledSlider, { toggleSize: size, checked: checked, disabled: disabled }))),
        infoTooltip && (React.createElement(Flex, { ml: apolloSpaceInsetHalfX, alignItems: "center" },
            React.createElement(InfoIconTooltip, null, infoTooltip)))));
};
export default Toggle;
//# sourceMappingURL=Toggle.js.map